export default "__VITE_ASSET__BII_wj0P__"